import { snackbar } from "components-redesign/Snackbar";
import { TypographyBodyLarge } from "components-redesign/Typography/Typography";
import { useCurrentUserMenuStyles } from "components/Layout/NavigationMenu/styles";
import { ListItemIcon, MenuItem } from "components/mui-core";
import { ReactComponent as MfaDisableIcon } from "icons/navbar/currentUserMenu/mfa-disable.svg";
import { ReactComponent as MfaEnableIcon } from "icons/navbar/currentUserMenu/mfa-enable.svg";
import { useMemo, useState } from "react";

import { useSelector } from "react-redux";
import RemoveMFA from "./RemoveMFA";
import SetupMFA from "./SetupMFA";

const ManageOwnMFA = () => {
  const { classes } = useCurrentUserMenuStyles();
  const [isDialogOpened, setDialogOpened] = useState(false);

  const hasMFA = useSelector(
    (state: any) =>
      state?.auth?.mfa?.mfaEnabled && state?.auth?.mfa?.mfaSharedSecret
  );

  const dataQa = useMemo(
    () => (hasMFA ? "remove-mfa_trigger-element" : "setup-mfa_trigger-element"),
    [hasMFA]
  );

  const title = useMemo(() => (hasMFA ? "Remove MFA" : "Setup MFA"), [hasMFA]);

  const dialog = useMemo(() => {
    if (!isDialogOpened) return null;

    if (hasMFA) {
      return (
        <RemoveMFA
          setDialogOpened={setDialogOpened}
          onRemove={() => snackbar.success("MFA successfully removed")}
        />
      );
    }

    return (
      <SetupMFA
        setDialogOpened={setDialogOpened}
        onSetup={() => snackbar.success("MFA successfully set")}
      />
    );
  }, [hasMFA, isDialogOpened]);

  return (
    <>
      <div className={classes.link}>
        <MenuItem
          key="MFA"
          className={classes.listItem}
          data-qa={dataQa}
          onClick={() => setDialogOpened(true)}>
          <ListItemIcon>
            {hasMFA ? <MfaDisableIcon /> : <MfaEnableIcon />}
          </ListItemIcon>
          <TypographyBodyLarge sx={{ width: "100%" }}>
            {title}
          </TypographyBodyLarge>
        </MenuItem>
      </div>
      {dialog}
    </>
  );
};

export default ManageOwnMFA;
